import {
  __async
} from "../chunk-7B52C2XE.js";
function waitUntilTrue(condition, timeoutMs, intervalMs) {
  return __async(this, null, function* () {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (yield condition()) {
        return true;
      }
      yield new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
    return false;
  });
}
export {
  waitUntilTrue
};
